export const contatos_empty = () => ({
  telefones: [{ value: "" }],
  emails: [{ value: "" }],
  redes_sociais: [{ value: "" }],
});
